import React from "react";
import { BtnAlternative } from "../../share/buttons/Btn";

function SaveBootcamps({ item }) {
    const remainingDays = (date) => {
        const now = new Date().toISOString();
        const DAY_UNIT_IN_MILLISECONDS = 24 * 3600 * 1000;

        const diffInMilliseconds =
            new Date(now).getTime() - new Date(date).getTime();
        const diffInDays = Math.round(
            diffInMilliseconds / DAY_UNIT_IN_MILLISECONDS
        );
        return diffInDays;
    };

    const now = new Date().toISOString();
    console.log(now);
    return (
        <div>
            <p className=" text-[#77498F] text-[1.4rem] font-normal leading-[2.4rem] mb-[2.1rem]">
                {item.reults.bootcamp_name}
            </p>
            <p className=" text-[#212121E5] text-[1.2rem] font-normal leading-[2.4rem] mb-[1.3rem]">
                <span className=" text-[#21212199] text-[1.2rem] font-normal leading-[2.4rem]">
                    {" "}
                    استاد:
                </span>
                {item.reults.bootcamp_organizer}
            </p>
            <p className=" text-[#212121E5] text-[1.2rem] font-normal leading-[2.4rem] mb-[1.2rem]">
                <span className=" text-[#21212199] text-[1.2rem] font-normal leading-[2.4rem]">
                    دسته بندی:
                </span>
                {item.reults.bootcamp_category}
            </p>
            <p className=" text-[#212121E5] text-[1.2rem] font-normal leading-[2.4rem] mb-[2.1rem]">
                <span className=" text-[#21212199] text-[1.2rem] font-normal leading-[2.4rem]">
                    {" "}
                    مدت زمان مانده تا شروع:
                </span>
                {remainingDays(item.reults.bootcamp_start_date)} روز
            </p>
            <BtnAlternative text="صفحه دوره" className="px-4 py-7" />
        </div>
    );
}

export default SaveBootcamps;
